<script setup lang="ts">
const { t } = useI18n()
const { data: home } = await useAsyncData('home-nav', () => queryCollection('home').first())

const navItems = computed(() => {
  return (home.value?.nav ?? []).map(item => {
    if (item.to === '/#games') {
      const gameLinks = (home.value?.games ?? [])
        .filter(g => g.status === 'available' && g.route)
        .sort((a, b) => (a.order ?? 99) - (b.order ?? 99))
        .map(g => ({ icon: g.icon, label: g.title, to: g.route! }))
      if (gameLinks.length) {
        return { ...item, children: gameLinks, type: 'trigger' as const }
      }
      return item
    }
    return item
  })
})
</script>

<template>
  <div>
    <UHeader>
      <template #left>
        <NuxtLink
          to="/"
          class="flex items-center gap-2 font-semibold text-highlighted"
        >
          <UIcon
            name="mdi:fire"
            class="text-primary size-5"
          />
          {{ t('site.name') }}
        </NuxtLink>
      </template>

      <template #right>
        <UNavigationMenu
          :items="navItems"
          variant="link"
          :ui="{ link: 'text-muted hover:text-highlighted transition-colors', linkLeadingIcon: 'text-dimmed group-hover:text-default transition-colors' }"
          class="hidden lg:flex"
        />
        <UColorModeButton/>
      </template>

      <template #body>
        <UNavigationMenu
          :items="navItems"
          orientation="vertical"
          :ui="{ link: 'text-muted hover:text-highlighted transition-colors', linkLeadingIcon: 'text-dimmed group-hover:text-default transition-colors' }"
          class="-mx-2.5"
        />
      </template>
    </UHeader>

    <UMain>
      <slot/>
    </UMain>

    <USeparator icon="mdi:fire"/>

    <UFooter>
      <template #left>
        <div class="flex flex-col items-center gap-1 sm:flex-row sm:items-center sm:gap-3">
          <p class="text-sm text-muted">
            {{ t('footer.copyright', { year: new Date().getFullYear() }) }}
          </p>
          <nav class="flex justify-center gap-3">
            <NuxtLink
              to="/eula"
              class="text-sm text-muted hover:text-highlighted transition-colors"
            >
              {{ t('footer.eula') }}
            </NuxtLink>
            <NuxtLink
              to="/privacy-policy"
              class="text-sm text-muted hover:text-highlighted transition-colors"
            >
              {{ t('footer.privacyPolicy') }}
            </NuxtLink>
          </nav>
        </div>
      </template>

      <template #right>
        <div class="flex items-center gap-1.5">
          <span class="text-sm text-muted">{{ t('footer.developedBy') }}</span>
          <a
            href="https://kaweah.tech"
            target="_blank"
            aria-label="Go to the Kaweah Tech website in a new window"
          >
            <UColorModeImage
              class="h-4 object-scale-down"
              alt="Kaweah Tech"
              light="https://assets.kaweah.tech/kaweah-tech-logo-dark.svg"
              dark="https://assets.kaweah.tech/kaweah-tech-logo-lite.svg"
            /></a>
        </div>
      </template>
    </UFooter>
  </div>
</template>
